import { render, staticRenderFns } from "./howToUseCard.vue?vue&type=template&id=71eec923&scoped=true&"
import script from "./howToUseCard.vue?vue&type=script&lang=js&"
export * from "./howToUseCard.vue?vue&type=script&lang=js&"
import style0 from "./howToUseCard.vue?vue&type=style&index=0&id=71eec923&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eec923",
  null
  
)

export default component.exports